import { createAction, props } from '@ngrx/store';
import { IQObservation } from '../../models/iq-observation.model';

export enum GetIQObservationsAction {
  REQUEST = '[IQ Observations] Get Observations Request',
  SUCCESS = '[IQ Observations] Get Observations Success',
  FAIL = '[IQ Observations] Get Observations Fail',
}

export const getIQObservations = createAction(
  GetIQObservationsAction.REQUEST,
  props<{ showMockData: boolean }>(),
);

export const getIQObservationsFail = createAction(
  GetIQObservationsAction.FAIL,
  props<{ error: unknown }>(),
);

export const getIQObservationsSuccess = createAction(
  GetIQObservationsAction.SUCCESS,
  props<{ observations: IQObservation[] }>(),
);
